export default __webpack_public_path__ + "static/topbar-background-b22f9d800351ffa3020ee11574c4b978.webp";